export const PORTFOLIO_OPTIONAL_DATA_FORM = 'portfolio-optional-data-form';
export const PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY = 'portfolio-optional-data-form-field-array';
